import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'

export default class extends Component {
  render() {
    const header = ['团队管理', '团队主页']

    return (
      <HeaderView header={header} title="团队主页">
        a
      </HeaderView>
    )
  }
}
